import React, { useEffect, useRef, useState } from 'react';
import './MascotBubble.css';

interface MascotBubbleProps {
  message: string;
  visible: boolean;
}

// 伺か/SSP系の定番にならったタイプライター表示速度（1文字ごとの待ち時間）
const TYPE_INTERVAL_MS = 60;

const MascotBubble: React.FC<MascotBubbleProps> = ({ message, visible }) => {
  const [typedCount, setTypedCount] = useState(0);
  const [shouldRender, setShouldRender] = useState(false);
  const intervalRef = useRef<number | null>(null);

  // タイプライター式に1文字ずつ表示
  useEffect(() => {
    if (visible && message) {
      setShouldRender(true);
      setTypedCount(0);
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = window.setInterval(() => {
        setTypedCount((prev) => {
          if (prev >= message.length) {
            if (intervalRef.current) {
              clearInterval(intervalRef.current);
              intervalRef.current = null;
            }
            return prev;
          }
          return prev + 1;
        });
      }, TYPE_INTERVAL_MS);
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [visible, message]);

  // フェードアウトが終わってからアンマウント
  useEffect(() => {
    if (!visible && shouldRender) {
      const timer = setTimeout(() => setShouldRender(false), 300);
      return () => clearTimeout(timer);
    }
  }, [visible, shouldRender]);

  if (!shouldRender) return null;

  return (
    <div
      className={`mascot-bubble ${visible ? 'mascot-bubble--visible' : ''}`}
      onClick={() => setTypedCount(message.length)}
      title="クリックで全文表示"
    >
      <div className="mascot-bubble__content">
        {/* サイズ確保用の透明な全文（タイプ中に吹き出しが伸び縮みしないように） */}
        <span className="mascot-bubble__ghost" aria-hidden="true">
          {message}
        </span>
        <span className="mascot-bubble__typed">
          {message.slice(0, typedCount)}
        </span>
      </div>
    </div>
  );
};

export default MascotBubble;
